import { useMemo, useCallback, useContext } from 'react';
import { format, addDays, startOfMonth, differenceInMonths, isSameMonth, isSameDay, isWeekend } from 'date-fns';

import { LocaleContext } from 'context/LocaleContext';

const GanttChartScaleDays = ({ chartStart, chartDuration, scaleItemWidth }) => {
    const localeCtx = useContext(LocaleContext);

    const chartDays = useMemo(() => {
        return new Array(chartDuration).fill(0).map((item, index) => addDays(chartStart, index));
    }, [chartDuration, chartStart]);

    const getNextMonthFirstDay = useCallback(targetDate => {
        const index = chartDays.findIndex(chartDay => {
            const startForChartDay = startOfMonth(chartDay);
            const startForTargetDate = startOfMonth(targetDate);

            return differenceInMonths(startForChartDay, startForTargetDate) > 0;
        });

        if (index === -1) {
            return chartDays.length;
        }

        return index;
    }, [chartDays]);

    let prevDay;

    return (
        <div className="gantt-chart-scale">
            <div className="scale-items-secondary">
                {
                    chartDays.map((date, index) => {
                        if (prevDay && isSameMonth(date, prevDay)) {
                            return null;
                        }

                        prevDay = date;

                        const startPx = index * scaleItemWidth;
                        const endPx = getNextMonthFirstDay(date) * scaleItemWidth;

                        return <div className="scale-item-secondary" key={index} style={{ left: `${startPx}px`, width: `${endPx - startPx}px`}}>{format(date, 'MMMM')}</div>
                    })
                }
            </div>

            <div className="scale-items">
                {
                    chartDays.map((date, index) => (
                        <div
                            key={index}
                            className={'scale-item' + (isSameDay(date, new Date()) ? ' today': '') + (localeCtx?.ignoreWeekends && isWeekend(date) ? ' weekend' : '')}
                            style={{ width: `${scaleItemWidth}px`}}
                        >
                            <div className="scale-item-inner">
                                <strong>{format(date, 'EEE')}</strong>
                                <span>{format(date, 'd')}</span>
                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

export default GanttChartScaleDays;
